import * as React from 'react';
import ReactDOM__default from 'react-dom';

const Portal = ({ children  })=>{
    const [modalRoot, setModalRoot] = React.useState(null);
    React.useEffect(()=>{
        setModalRoot(document ? document.body : null);
    }, []);
    if (!modalRoot) return null;
    return /*#__PURE__*/ ReactDOM__default.createPortal(children, modalRoot);
};

export { Portal };
//# sourceMappingURL=Portal.js.map
